/**
 * StudentAccountScreen — « Mon compte » de l'élève (route `account`), à la place de
 * `student/account/MyAccountScreen.js` quand l'espace élève est allumé.
 *
 * Patron A : le compte relu à l'ouverture (`useStudentAccountData`), mis en forme par
 * `studentAccountViewModel`, les gestes et les deux écritures (avatar, titre) dans
 * `useStudentAccountState`, la génération d'un avatar par IA dans `useStudentAvatarAI`
 * (`openAIAvatarModal` l'ouvre d'office, comme `MyAccountScreen.js`).
 */
import React from "react"
import { useSelector } from "react-redux"

import { StudentAccountPage } from "../../../../../../design-system/student"
import { studentAccountViewModel } from "../../../../view-models/student/Account/studentAccountViewModel"
import { type StudentSpaceScreenProps } from "../studentSpaceRouteTypes"
import { useStudentAccountData } from "./useStudentAccountData"
import { useStudentAccountState } from "./useStudentAccountState"
import { useStudentAvatarAI } from "./useStudentAvatarAI"

export function StudentAccountScreen({ route }: StudentSpaceScreenProps) {
    useStudentAccountData()
    const vm = useSelector(studentAccountViewModel)
    const avatarAI = useStudentAvatarAI({ openOnArrival: route?.params?.openAIAvatarModal === true })
    const state = useStudentAccountState(vm, avatarAI)

    return (
        <StudentAccountPage
            identity={vm.identity}
            loading={vm.loading}
            profileCompletion={vm.profileCompletion}
            gamification={vm.gamification}
            titleProgress={vm.titleProgress}
            statistics={vm.statistics}
            initialStatisticsPeriodKey={vm.initialStatisticsPeriodKey}
            avatarBusy={vm.avatarBusy}
            {...state}
            titleModal={{ ...state.titleModal, selectedId: vm.selectedTitleId }}
            avatarAI={avatarAI.sheet}
        />
    )
}
